<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6 col-xl-5">
                        <div class="font-weight-bold body-1">
                            Editar nómina
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6" xl="5">
                        <v-form ref="form" @submit.prevent="save">
                            <payroll-form ref="PayrollForm" :values="form" @save="save" :serverErrors="serverErrors"></payroll-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" xl="5" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import PayrollForm from "./Form.vue";
import Utils from '../../../../helpers/Utils';
export default {
    components: {
        'payroll-form': PayrollForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            serverErrors: {},
            form: {
                name: "",
                fiscal_salary: "",
                integrated_salary: "",
                isn: "",
                ims_cost: "",
                infonavit_cost: "",
                amortization_infonavit: "",
                // total_cost_salary: "",
                
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "PayrollEmployees",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;

			return this.$refs.form.validate();
            // return true;
		},
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.payroll.get(this.id)
                .then((resp) => {
                    // console.log(this.$refs)
                    this.form.name = resp.data.name;
                    this.form.fiscal_salary = ""+resp.data.current_contract.fiscal_salary??"";
                    this.form.integrated_salary = ""+resp.data.current_contract.integrated_salary??"";
                    this.form.ims_cost = ""+resp.data.current_contract.ims_cost??"";
                    this.form.infonavit_cost = ""+resp.data.current_contract.infonavit_cost??"";
                    this.form.isn = ""+resp.data.current_contract.isn??"";
                    this.form.amortization_infonavit = ""+resp.data.current_contract.amortization_infonavit??"";
                    // this.form.total_cost_salary = ""+resp.data.current_contract.total_cost_salary??"";

                    
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.payroll.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'PayrollEmployees'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            delete data.name;

            data.fiscal_salary = parseFloat(data.fiscal_salary);
            data.integrated_salary = parseFloat(data.integrated_salary);
            data.ims_cost = parseFloat(data.ims_cost);
            data.infonavit_cost = parseFloat(data.infonavit_cost);
            data.isn = parseFloat(data.isn);
            data.amortization_infonavit = parseFloat(data.amortization_infonavit);
            // data.total_cost_salary = parseFloat(data.total_cost_salary);

            return data;
        },
    },
}
</script>

<style>

</style>